export class BenQProjector {
    constructor(socket, log) {
        this.socket = socket;
        this.power = false;
        this.displayBlank = false;
        this.displayFreeze = false;
        this.videoSelection = 'hdmi';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'blank',
                regExp: /\*blank=(\?|on|off)#/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.displayBlank = match[1].toLowerCase() === 'on';
                    }
                    this.socket.send(`\r*blank=${this.displayBlank ? 'on' : 'off'}#`);
                },
            },
            {
                name: 'freeze',
                regExp: /\*freeze=(\?|on|off)#/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.displayFreeze = match[1].toLowerCase() === 'on';
                    }
                    this.socket.send(`\r*freeze=${this.displayFreeze ? 'on' : 'off'}#`);
                },
            },
            {
                name: 'power',
                regExp: /\*pow=(\?|on|off)#/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.power = match[1].toLowerCase() === 'on';
                    }
                    this.socket.send(`\r*pow=${this.power ? 'on' : 'off'}#`);
                },
            },
            {
                name: 'videoInput',
                regExp: /\*sour=(\?|.+)#/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.videoSelection = match[1].toLowerCase();
                    }
                    this.socket.send(`\r*sour=${this.videoSelection}#`);
                },
            },
            {
                name: 'volume',
                regExp: /\*vol=(\?|\d+)#/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.volume = parseInt(match[1], 10);
                    }
                    this.socket.send(`\r*vol=${this.volume}#`);
                },
            },
            {
                name: 'volumeMute',
                regExp: /\*mute=(\?|on|off)#/i,
                callback: (match) => {
                    if (match[1] !== '?') {
                        this.volumeMute = match[1].toLowerCase() === 'on';
                    }
                    this.socket.send(`\r*mute=${this.volumeMute ? 'on' : 'off'}#`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`illegal format`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (this.videoSelection === lowestCode)
                return;
            if (lowestCode === undefined ||
                parseInt(videoInput.code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = videoInput.code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 'hdmi';
    }
}
BenQProjector.emulatorType = 'socketEmulator';
BenQProjector.key = '-LwEnhXVHiKWie-oNXt9';
